import { render } from "./TabsList.vue?vue&type=template&id=f57a00d0&scoped=true"
import script from "./TabsList.vue?vue&type=script&lang=js"
export * from "./TabsList.vue?vue&type=script&lang=js"

import "./TabsList.vue?vue&type=style&index=0&id=f57a00d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f57a00d0"]])

export default __exports__